const initialState = {
  selectedRegion: '',
  searchString: '',
};

export default initialState;